import { render, staticRenderFns } from "./CadastrosWrapper.vue?vue&type=template&id=019b7f9c"
import script from "./CadastrosWrapper.vue?vue&type=script&lang=js"
export * from "./CadastrosWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports